import React, { MouseEvent } from "react";
import Box from "@mui/material/Box";
import { getBlockConfig } from "../../models/block";
import { colors } from "../../styles/theme";
import { BlockImage } from "../block/BlockImage";
//import { useAppSelector } from "../../hooks";
//import { selectAccountBalance } from "../../store/game/selectors";
import { BlockTypes } from "../../models/block-types";

interface Props {
  blockType: BlockTypes;
  onItemClick: (
    e: MouseEvent<HTMLButtonElement | HTMLDivElement>,
    blockType: BlockTypes,
  ) => void;
  disableInteractivity?: boolean;
}

export const PaletteItem: React.FC<Props> = ({
  blockType,
  onItemClick,
  disableInteractivity = false,
}) => {
  const config = getBlockConfig(blockType);
  // const accountBalance = useAppSelector((state) =>
  //   selectAccountBalance(state.game),
  // );
  //const canAfford = accountBalance >= config.purchasePrice;
  const isDisabled = disableInteractivity; // && !canAfford;

  const backgroundColor = isDisabled ? colors.grey[300] : "white";
  const hoverBackgroundColor = isDisabled ? colors.grey[300] : colors.grey[100];
  const cursor = isDisabled ? "not-allowed" : "pointer";
  return (
    <Box
      draggable
      onDragStart={(e) => {
        e.dataTransfer.setData("application/reactflow", blockType);
        e.dataTransfer.effectAllowed = "move";

        const img = e.currentTarget.querySelector("img");
        if (img) {
          const clone = img.cloneNode(true) as HTMLElement;
          clone.style.opacity = "0.5";
          clone.style.position = "absolute";
          clone.style.top = "-1000px";
          clone.style.left = "-1000px";
          document.body.appendChild(clone);
          e.dataTransfer.setDragImage(clone, 0, 0);

          // Remove the clone after a short delay to ensure it's used for the drag image
          setTimeout(() => {
            document.body.removeChild(clone);
          }, 0);
        }
      }}
      sx={{
        width: "100%",
        cursor,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "2px",
        borderRadius: "5px",
        padding: "4px 0",
        backgroundColor,
        border: "solid black 1px",
        "&:hover": {
          backgroundColor: hoverBackgroundColor,
        },
        minHeight: "85px",
      }}
      data-testid={`palette-item-${blockType}`}
      onClick={(e) => onItemClick(e, blockType)}
    >
      <Box
        sx={{
          width: "60px",
          height: "60px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <BlockImage width={50} height={50} blockType={blockType} />
      </Box>
      {!disableInteractivity && (
        <Box
          sx={{
            fontSize: "9px",
            fontWeight: 600,
            textAlign: "center",
            lineHeight: 1.2,
            color: "#333",
            px: "2px",
            wordBreak: "break-word",
          }}
        >
          {config.displayName}
          {/* TODO: Add account price back in someday:  : $${config.purchasePrice}*/}
        </Box>
      )}
    </Box>
  );
};
